// extracted by mini-css-extract-plugin
export default {"icon-external":"support-button_icon-external__ekofs","icon-help":"support-button_icon-help__0mu43"};